module.exports = __webpack_public_path__ + "static/media/speak.5b5b4619.mp3";